var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnicargoDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69359 11.6852H6.68166H4.90489L8.02914 4.50107L11.1534 11.6852H9.37663H9.3647V13.8483H9.37663H11.9233H16L10.6194 2.24005L9.68124 0.151733H9.65139H6.4069L0 13.8483H4.13495H6.68166H6.69359V11.6852Z",
    fill: "#3B4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicargoDropdown);
export default __webpack_public_path__ + "static/media/UnicargoDropdown.eb83682200e7e42f4e0f748bb01d5b2e.svg";
export { ForwardRef as ReactComponent };